export enum TailStatusEnum {
  Parked = 0,
  InFlight,
  OnGround
}
